<template>
    <div v-can:read-tab="'prospects'">
        <div class="h2">
            Listing des prospects
        </div>

        <hr>
        <DossierCreate
            class="float-right"
            label="Prospect"
            :options="{type:'prospect'}"
        />
        <div class="clearfix" />
        <form
            class="mt-3 py-4 shadow px-3"
            @submit.prevent="search"
        >
            <div class="row">
                <div class="col-6 h4">
                    Recherche de prospects
                </div>
            </div>

            <div class="form-row mt-4">
                <div class="col-2">
                    <base-input
                        v-model="params.client"
                    >
                        Client
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.email"
                        :errors="errors.email"
                    >
                        Email
                    </base-input>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.cabinets"
                        :options="[{value: '', label: 'Non renseigné'}, ...optionsCabinets]"
                        multiple
                    >
                        Cabinet
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.commercial"
                        :options="[{value: '', label: 'Non renseigné'}, ...optionsCommerciaux]"
                        multiple
                    >
                        Commercial
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.provenance"
                        :options="[{label: '', value: null}, ...optionsProspectProvenance]"
                    >
                        Provenance
                    </base-select>
                </div>

                <div
                    v-if="params.provenance === 'partenaire'"
                    class="col-2"
                >
                    <base-select
                        v-model="params.provenances"
                        multiple
                        src="/api/provenances/autocomplete"
                    >
                        Partenaire
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.typeMissions"
                        :options="optionsTypeMissionsWithoutMicroBic"
                        multiple
                    >
                        Type de mission
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.programme_nom"
                        :options="optionsProgrammeNom"
                        multiple
                    >
                        Nom du programme
                    </base-select>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.programme_adresse"
                    >
                        Adresse ou cp du programme
                    </base-input>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.sans_suite"
                        :options="optionsOuiNon"
                    >
                        Sans suite
                    </base-select>
                </div>
                <div
                    v-if="params.sans_suite"
                    class="col-2"
                >
                    <base-select
                        v-model="params.raison_sans_suite"
                        :options="[{label: '', value: null},{ label:'Proximité', value:'proximite'},{ label:'Tarifs', value:'tarifs'},{ label:'Projet annulé', value:'projet_annule'},{ label:'Sans motif', value:'sans_motif'},{ label:'Autre', value:'autre'}]"
                    >
                        Raisons
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.parrainage"
                        :options="optionsOuiNon"
                    >
                        Parrainage
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.actif"
                        :options="optionsOuiNon"
                    >
                        Actif
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.prospectStatut"
                        :options="[{ label : 'Tous', value: 0 }, ...optionsProspectStatut]"
                    >
                        Statut
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.typeIndivisions"
                        :errors="errors.typeIndivisions"
                        :options="optionsTypesIndivisions"
                        multiple
                    >
                        Indivision/Société
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.mode_detention"
                        :options="optionsModeDetention"
                        multiple
                    >
                        Mode de détention
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.retro"
                        :options="[{ value: null, label: '' }, ...optionsRetro]"
                    >
                        Type rétro
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-input
                        v-model="params.date_contact_min"
                        type="date"
                        :max="now()"
                    >
                        Date contact après le
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.date_contact_max"
                        type="date"
                        :max="now()"
                    >
                        Date contact avant le
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.date_envoi_ldm_min"
                        type="date"
                    >
                        Envoi LDM après le
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.date_envoi_ldm_max"
                        type="date"
                    >
                        Envoi LDM avant le
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.date_reception_ldm_min"
                        type="date"
                    >
                        Réception LDM après le
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.date_reception_ldm_max"
                        type="date"
                    >
                        Réception LDM avant le
                    </base-input>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.logiciel_compta"
                        :options="optionsLogicielCompta"
                        multiple
                    >
                        Logiciel de comptabilité
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.pack"
                        :options="optionsPack"
                        multiple
                    >
                        Pack
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-input
                        v-model="params.id_externe_client"
                        type="text"
                    >
                        Identifiant externe client
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input
                        v-model="params.id_externe_lot"
                        type="text"
                    >
                        Identifiant externe lot
                    </base-input>
                </div>
            </div>

            <button
                type="submit"
                class="btn btn-success float-right mt-3 px-4"
            >
                Rechercher
            </button>

            <button
                class="btn btn-info float-right mt-3 px-4 mr-2"
                @click.prevent="reinit"
            >
                Réinitialiser
            </button>
            <span class="clearfix" />
        </form>

        <base-table
            :items="items"
            :meta="meta"
            :params="exParams"
            :loading="loading"
            :head="head"
            name="prospect"
            class="mt-5"
            @orderBy="orderBy"
            @change-page="goToPage"
            @paginate="paginate"
            @export="exportExcel"
        >
            <div
                slot="extra-buttons"
                class="d-inline-block"
            >
                <button
                    v-can:exec-action="'mails.personnalise_massif'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de lister et d\'envoyer massivement les mails de collecte des pièces manquantes ' +
                        'et les envoyer à tous les prospects pour lesquels l\'envoie de mail est activé.'"
                    @click="showModalGenerationMailsCollectPiecesManquantes = true"
                >
                    Générer mails collecte pièces manquantes
                </button>

                <button
                    v-can:exec-action="'mails.personnalise_massif'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de lister et d\'envoyer massivement un mail personnalisé ' +
                        'et les envoyer à tous les prospects pour lesquels l\'envoie de mail est activé.'"
                    @click="showModalMailsPersonnalise = true"
                >
                    Rédiger nouveau mail massif
                </button>
            </div>

            <tr
                v-for="dossier of items"
                :key="dossier.id"
                :class="{'text-danger': !dossier.is_actif, 'strikethrough': !dossier.is_actif}"
            >
                <td>{{ dossier.prospect.date_contact | frenchDate }}</td>
                <td>
                    <template v-if="dossier.client.is_indivision">
                        {{ dossier.client.type_indivision }} {{ dossier.client.libelle_indivision }}
                    </template>
                    <template v-else>
                        {{ dossier.client.nom }} {{ dossier.client.prenom }}
                    </template>
                </td>
                <td>{{ optionToLabel(optionsProspectProvenance, dossier.prospect.provenance) }}</td>
                <td>{{ dossier.client.telephone }}</td>
                <td>{{ dossier.client.email }}</td>
                <td>{{ dossier.date_debut_activite | frenchDate }}</td>
                <td>{{ dossier.cabinet !== null ? dossier.cabinet.nom : '' }}</td>
                <td>{{ dossier.commercial !== null ? dossier.commercial.nom + ' ' + dossier.commercial.prenom : '' }}</td>
                <td>{{ dossier.updated_at_global | frenchDateTime }}</td>
                <td>{{ dossier.prospect.sans_suite ? 'Sans suite' : optionToLabel(optionsProspectStatut, dossier.prospect.statut_id) }}</td>
                <td class="text-center">
                    <router-link
                        v-can:read-model="'dossier'"
                        :to="{name: 'dossier', params: {id: dossier.id}}"
                        class="btn btn-primary btn-sm"
                        title="Voir"
                    >
                        <i class="fa fa-glasses" />
                    </router-link>

                    <button
                        v-if="dossier.type === 'prospect'"
                        v-can:delete-model="'prospect'"
                        class="btn btn-danger btn-sm"
                        title="Supprimer le prospect"
                        @click="remove(dossier.id)"
                    >
                        <i class="fa fa-times" />
                    </button>
                </td>
            </tr>
        </base-table>

        <GenererMailsCollectePiecesManquantesModal
            v-if="showModalGenerationMailsCollectPiecesManquantes"
            :additional-params="exParams"
            @close="showModalGenerationMailsCollectPiecesManquantes = false"
        />

        <SelectionDossiersDeClientsModal
            v-if="showModalMailsPersonnalise"
            :additional-params="exParams"
            :type="'prospect'"
            @close="showModalMailsPersonnalise = false"
            @next-step="nextStepMailsPersonnalises"
        />

        <MailEditModal
            v-if="showModalEditMail !== null"
            :mail="showModalEditMail"
            :dossiers="dossiersId"
            @close="showModalEditMail = null"
            @reload="search()"
        />
    </div>
</template>

<script>
    import BaseInput from "../templates/BaseInput"
    import BaseSelect from "../templates/BaseSelect"
    import BaseTable from "../templates/BaseTable"
    import DossierCreate from "../actions/DossierCreate"
    import DossierSearch from "../../mixins/DossierSearch"
    import StatistiqueHistorique from "../../mixins/StatistiqueHistorique"
    import GenererMailsCollectePiecesManquantesModal from "../modals/GenererMailsCollectePiecesManquantesModal"
    import SelectionDossiersDeClientsModal from "../modals/SelectionDossiersDeClientsModal"
    import MailEditModal from "../modals/MailEditModal"
    import {mapGetters} from "vuex"

    export default {
        name: "ProspectsList",

        components: {
            BaseInput,
            BaseSelect,
            DossierCreate,
            BaseTable,
            GenererMailsCollectePiecesManquantesModal,
            SelectionDossiersDeClientsModal,
            MailEditModal,
        },

        mixins: [StatistiqueHistorique, DossierSearch],

        data: function () {
            return {
                params: this.initParams(),

                optionsOuiNon: [
                    {value: '', label: 'Tous'},
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                ],

                head: {
                    date_contact: 'Date contact',
                    client: "Client",
                    provenance: "Provenance",
                    telephone: "Téléphone",
                    email: "Email",
                    date_debut_activite: "Date début d'activité",
                    cabinet: "Cabinet",
                    commercial: "Commercial",
                    updated_at_global: "Dernière modification",
                    statut: "Statut"
                },

                showModalGenerationMailsCollectPiecesManquantes: false,
                showModalMailsPersonnalise: false,
                showModalEditMail: null,

                dossiersId: [],
            }
        },

        computed: {
            ...mapGetters([
                'optionsCabinets',
                'optionsCommerciaux',
                'optionsEquipes',
                'optionsLogicielCompta',
                'optionsPack',
                'optionsTypeMissionsWithoutMicroBic',
                'optionsRegimesTVA',
                'optionsProgrammeCP',
                'optionsProgrammeNom',
                'optionsProspectStatut',
                'optionsProspectProvenance',
                'optionsModeDetention',
                'optionsTypesIndivisions',
                'optionsRetro',
                'me',
            ]),
        },

        methods: {
            /**
             * Réinitialise les paramètres
             */
            reinit: function () {
                this.params = this.initParams()
            },

            /**
             * Initialise les paramètres
             */
            initParams: function () {
                return {
                    type: ['prospect'],
                    paginate: 15,
                    cree: 0,
                    actif: 1,
                    clientSorti: 0,
                    dossierSorti: 0,
                    prospectStatut: 0,
                    sans_suite: 0,
                    excludeProspect: 0,
                    direction: 'desc',
                    order: 'date_contact',
                }
            },

            optionToLabel: function(options, value) {
                const selectedOption = options.filter(option => option.value === value)

                return selectedOption.length ? selectedOption[0].label : null
            },

            nextStepMailsPersonnalises: function(payload) {
                this.showModalMailsPersonnalise = false
                this.showModalEditMail = {type_id: payload.type_id}
                this.dossiersId = payload.dossiersId
            },

            /**
             * Supprime un dossier
             * @param id
             */
            remove: function (id) {
                this.$confirm('Êtes-vous certain de vouloir supprimer ce prospect ?').then(() => {
                    let key = this.items.findIndex(dossier => dossier.id === id)

                    this.items.splice(key, 1)

                    axios.delete(`/api/dossiers/${id}`)
                        .then(() => this.$notify('success', 'Le prospect a bien été supprimé.'))
                        .catch(() => this.$notify('danger', 'Une erreur est survenue lors de la suppression.'))
                })
            },
        }
    }
</script>

<style lang="scss" >
  .text-success.checkmark-icon {
    color:#5578eb!important;
  }
</style>

